import React,{useEffect} from 'react';
import { Header,Footer } from './components/index';
import { MainPage } from './pages';
import { init } from './hepers/smoothDisplaying';



function App() {


  useEffect(()=>{
    setTimeout(()=>{
      let elements:any=document.querySelectorAll('.title-text,.values-section_blocks-placeholder,.middle-form');
      init(elements)
      console.log('edfghedrg')
    },500)
    
    
  },[])
  

  return (
    <div className="wrapper">
      <Header/>
        <div className='page '>
          <MainPage/>
        </div>
        
      <Footer/> 
    </div>
  );
}

export default App;
